
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'ServicesFrontCard',
  props: ['thisService'],
  setup(props) {
    const serviceData = ref(props.thisService);

    return {
      serviceData,
    };
  },
});
